module.exports = __webpack_public_path__ + "img/car_2.7fd1e0d9.png";